import AuthForm from "@/components/AuthForm";

export default function Login() {
  return <AuthForm mode="login" />;
}
